import Abstract from "../../../abstract-view/abstract.js";

import {
  fieldsetTrigger
} from "../../../../mixins/fieldset-trigger.js";

export default class Checkboxes extends Abstract {
  constructor(element) {
    super();
    this._element = element;

    this._checkboxesElements = null;
    this._titleElement = null;
  }

  getCheckboxesElements() {
    if (!this._checkboxesElements) {
      this._checkboxesElements = this._element.querySelectorAll(`.form-label`);
    }

    return this._checkboxesElements;
  }

  checkIfSomeChecked() {
    return Array.from(this._checkboxesElements)
      .map((item) => {
        const checkbox = item.querySelector(`input`);
        return checkbox.checked;
      })
      .some((item) => {
        return item;
      });
  }

  getTitleElement() {
    if (!this._titleElement) {
      this._titleElement = this._element.querySelector(`.filter-title`);
    }

    return this._titleElement;
  }
}

Object.assign(Checkboxes.prototype, fieldsetTrigger);
